<div class="login-container">
    <div class="wrapper" *ngIf="isLocal">
        <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <span class="login-form-logo"></span>
            <!-- Form Fields Begin here -->
            <div class="login-form-container">

                <!-- Email Field-->
                <mat-form-field class="login-form-input" appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput
                           type="email" 
                           name="email"
                           formControlName="email">
                        <mat-error *ngIf="loginForm.controls.email.hasError('required')">
                            Email is <strong>required</strong>
                        </mat-error>
                </mat-form-field>

                <!-- Password Field-->
                <mat-form-field class="login-form-input" appearance="outline">
                    <mat-label>Password</mat-label>
                    <input matInput
                           [type]="passwordHide ? 'password' : 'text'"
                           name="password" 
                           formControlName="password">
                    <button mat-icon-button matSuffix (click)="passwordHide = !passwordHide"
                          [attr.aria-label]="'Hide password'" [attr.aria-pressed]="passwordHide">
                        <mat-icon>{{passwordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error *ngIf="loginForm.controls.password.hasError('required')">
                        Password is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <p class="hasError" *ngIf="errorMessage">{{errorMessage}}</p>
            </div>
            <button class="login-form-btn"
                        type="submit"
                        [ngClass]="{'login-form-btn-disabled': loginForm.invalid && loginForm.touched }"
                        [disabled]="!loginForm.valid">
                            Login
            </button>
        </form>
    </div>
    <div class="wrapper" *ngIf="!isLocal">
        <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <span class="login-form-logo"></span>
        </form>

        <div class="labelCDN" >
            The access to this application is only available through CDN
        </div> 
        <div class="linkCDN" >
            <button class="login-form-btn"
            (click)="goToCDN()"
            type="button">Go to CDN</button>
        </div> 
    </div>

</div>